/**
 * EDR 기간(YYYYMM) 계산 — 운영보고서 화면과 관리자 화면이 공유한다.
 *
 * `now`를 인자로 받는다. 기본값을 두면 명시적 `undefined`도 현재 시각으로
 * 대체되어 테스트가 시각에 의존하게 된다.
 */

/** '202607' → '2026년 07월'. 빈 값은 빈 문자열 (드롭다운 placeholder용) */
export const formatPeriod = (period: string): string =>
  period ? `${period.slice(0, 4)}년 ${period.slice(4)}월` : '';

/** 당월부터 과거로 `count`개. 최신이 앞이다 */
export const recentPeriods = (now: Date, count: number): string[] =>
  Array.from({ length: count }, (_, i) => {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}`;
  });
